<div class=e174_9>
  <div  class="e174_10"></div>

  <!-- magic number 132 -->
  <div class="absolute container z-10 px-4" style="padding-top: 132px; height: 892px;">
    <ng-content></ng-content>
    <div class="grid grid-cols-12 gap-4 h-[9rem] place-content-center place-items-center">
      <div class="w-full col-span-10">
      </div>
      <div class="w-full col-span-2">
        <ng-container *ngIf="showNext">
          <app-button text="Next" (click)="onNext()">

          </app-button>
        </ng-container>
      </div>
    </div>
  </div>

  <div  class="e174_11"></div>
  <div  class="e174_12"></div>
  <div  class="e174_13"></div>

  <!-- title -->
  <span  class="e174_15">{{ title }}</span>

  <!-- flags and info -->
  <!--
       <div class=e174_16>
       <div class=ei174_16_14_43>
       <div  class="ei174_16_14_45"></div>
       <div  class="ei174_16_14_46"></div>
       <div  class="ei174_16_14_47"></div>
       <div  class="ei174_16_14_48"></div>
       <div  class="ei174_16_14_49"></div>
       </div>
       </div>
       <div class=e174_17>
       <div class=ei174_17_14_51>
       <div  class="ei174_17_14_53"></div>
       <div  class="ei174_17_14_54"></div>
       <div  class="ei174_17_14_55"></div>
       <div  class="ei174_17_14_56"></div>
       <div  class="ei174_17_14_57"></div>
       <div  class="ei174_17_14_58"></div>
       <div  class="ei174_17_14_59"></div>
       <div  class="ei174_17_14_60"></div>
       </div>
       </div>
       <div class=e174_18>
       <div class=ei174_18_14_62>
       <div  class="ei174_18_14_64"></div>
       <div  class="ei174_18_14_65"></div>
       <div  class="ei174_18_14_66"></div>
       <div  class="ei174_18_14_67"></div>
       <div  class="ei174_18_14_68"></div>
       <div  class="ei174_18_14_69"></div>
       <div  class="ei174_18_14_70"></div>
       <div  class="ei174_18_14_71"></div>
       <div  class="ei174_18_14_72"></div>
       <div  class="ei174_18_14_73"></div>
       <div  class="ei174_18_14_74"></div>
       <div  class="ei174_18_14_75"></div>
       </div>
       </div>
       <div class=e174_19>
       <div class=ei174_19_14_77>
       <div  class="ei174_19_14_79"></div>
       <div  class="ei174_19_14_80"></div>
       <div  class="ei174_19_14_81"></div>
       <div  class="ei174_19_14_82"></div>
       </div>
       </div>

       <div class=e174_20>
       <div class=ei174_20_50_235>
       <div class=ei174_20_50_236>
       <div  class="ei174_20_50_237"></div>
       <div  class="ei174_20_50_238"></div>
       </div>
       <div  class="ei174_20_50_239"></div>
       <div  class="ei174_20_50_240"></div>
       </div>
       <span  class="ei174_20_50_245">Tap “i” for information</span>
       </div>
  -->

  <!-- back button -->
  <div
    *ngIf="showBack"
    class="e174_21 z-20"
    (click)="onBack()"
  >
    <div class=ei174_21_97_395>
      <div  class="ei174_21_97_396">

      </div>
      <span  class="ei174_21_97_397">GO BACK</span>
    </div>
  </div>
</div>
